import { CustomeDetail } from "../../customerDetail/customerDetail";

export const CustomerDetailReport = () => {
  return (
    <CustomeDetail
      report="customerDetail"
      gridSize={{
        sm: 6,
        xs: 12,
      }}
    />
  );
};
